import React from 'react';
import { LanguageSwitcher } from './LanguageSwitcher';

interface AuthCardHeaderProps {
  language: string;
  onLanguageChange?: (language: string) => void;
  theme?: 'light' | 'dark';
  onThemeChange?: (theme: 'light' | 'dark') => void;
}

/** Logo + language switcher inside auth card (theme lives outside the card). */
export const AuthCardHeader: React.FC<AuthCardHeaderProps> = ({
  language,
  onLanguageChange,
}) => (
  <div className="flex items-start justify-between gap-3 mb-5">
    <img
      src="/logo-email.webp"
      alt="MyTravelDiary"
      className="h-12 sm:h-14 w-auto max-w-[60%] object-contain object-left"
    />
    {onLanguageChange ? (
      <LanguageSwitcher
        language={language}
        onChange={onLanguageChange}
        compact
      />
    ) : null}
  </div>
);

export default AuthCardHeader;
